import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "bg-black h-full" }
const _hoisted_2 = { class: "container mx-auto py-10 px-5" }
const _hoisted_3 = { class: "flex flex-col lg:max-w-2xl mx-auto space-y-10" }
const _hoisted_4 = { class: "text-white" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  width: "300",
  src: "/logo.png"
}, null, -1)
const _hoisted_6 = { class: "font-audiowide mt-6 text-xs" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "mt-8 font-audiowide text-red-500 text-md" }, "🚨 Don't use Trezor Wallet! ", -1)
const _hoisted_8 = {
  key: 0,
  class: "mt-8 font-audiowide text-red-500 text-xl"
}
const _hoisted_9 = { class: "mt-8 text-white font-audiowide flex flex-col md:flex-row" }
const _hoisted_10 = { class: "md:w-full divide-x" }
const _hoisted_11 = {
  target: "_blank",
  class: "mr-2 text-gold no-underline hover:underline",
  href: "https://medium.com/@MUSTCometh/how-to-connect-metamask-to-matic-mainnet-rpc-a97e1b79b65f"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  class: "pl-2 mr-2 text-gold no-underline hover:underline",
  href: "https://medium.com/@MUSTCometh/d3e1878f93f2"
}, "Tuto", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  class: "pl-2 text-gold no-underline hover:underline",
  href: "https://game.cometh.io"
}, "Game", -1)
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"flex flex-col md:flex-row md:justify-between\"><a href=\"https://t.me/cometh_io\" class=\"text-gold hover:text-white hover:text-opacity-100 transition duration-150 ease-in-out\"><svg xmlns=\"http://www.w3.org/2000/svg\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" stroke-linejoin=\"round\" stroke-miterlimit=\"1.414\" viewBox=\"0 0 24 24\" class=\"w-5 h-5 fill-current\"><path d=\"M18.384 22.779a1.19 1.19 0 001.107.145 1.16 1.16 0 00.724-.84C21.084 18 23.192 7.663 23.983 3.948a.78.78 0 00-.26-.758.8.8 0 00-.797-.14C18.733 4.602 5.82 9.447.542 11.4a.827.827 0 00-.542.799c.012.354.25.661.593.764 2.367.708 5.474 1.693 5.474 1.693s1.452 4.385 2.209 6.615c.095.28.314.5.603.576a.866.866 0 00.811-.207l3.096-2.923s3.572 2.619 5.598 4.062zm-11.01-8.677l1.679 5.538.373-3.507 10.185-9.186a.277.277 0 00.033-.377.284.284 0 00-.376-.064L7.374 14.102z\"></path></svg></a><a target=\"_blank\" class=\"ml-6 text-gold no-underline hover:text-white\" href=\"https://discord.gg/mcXn2R2QRx\">Discord</a></div>", 1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("hr", { class: "mt-1 mb-2 opacity-25" }, null, -1)
const _hoisted_16 = { class: "" }
const _hoisted_17 = { class: "" }
const _hoisted_18 = { class: "" }
const _hoisted_19 = {
  key: 0,
  class: "transition absolute flex flex-col lg:flex-row inset-0 bg-black bg-opacity-90 items-center justify-center text-red-500 text-center text-sm px-10"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("svg", {
  class: "hidden lg:block w-6 h-6 -ml-1 mr-2 mb-2 lg:mb-0",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M13 10V3L4 14h7v7l9-11h-7z"
  })
], -1)
const _hoisted_21 = {
  key: 0,
  class: "transition absolute flex inset-0 bg-black bg-opacity-75 items-center justify-center"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("svg", {
  class: "animate-spin h-8 w-8 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    class: "opacity-25",
    cx: "12",
    cy: "12",
    r: "10",
    stroke: "currentColor",
    "stroke-width": "4"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    class: "opacity-75",
    fill: "currentColor",
    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
  })
], -1)
const _hoisted_23 = [
  _hoisted_22
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UnlockForm = _resolveComponent("UnlockForm")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("p", _hoisted_6, "Transfer NFTs, ETH and tokens between " + _toDisplayString(_ctx.config.l1NetworkLabel) + " and " + _toDisplayString(_ctx.config.l2NetworkLabel) + " Network.", 1),
          _hoisted_7,
          (_ctx.noMetamask)
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, "Please use a Browser with Metamask"))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("a", _hoisted_11, "Setup " + _toDisplayString(_ctx.config.l2NetworkLabel), 1),
              _hoisted_12,
              _hoisted_13
            ]),
            _hoisted_14
          ]),
          _hoisted_15
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_UnlockForm, {
            name: 'Must (ERC20)',
            fn: _ctx.unlockERC20
          }, null, 8, ["name", "fn"])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_UnlockForm, {
            name: 'SpaceShip (ERC721)',
            fn: _ctx.unlockERC721
          }, null, 8, ["name", "fn"])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_UnlockForm, {
            name: 'Meme (ERC1155)',
            fn: _ctx.unlockERC1155
          }, null, 8, ["name", "fn"])
        ])
      ]),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (!_ctx.correctNetwork)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _hoisted_20,
                _createTextVNode(" Please connect to " + _toDisplayString(_ctx.config.l1NetworkLabel), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_Transition, {
        "enter-active-class": "transition ease-out duration-300",
        "enter-from-class": "opacity-0",
        "enter-to-class": "opacity-100",
        "leave-active-class": "transition ease-in duration-150",
        "leave-from-class": "opacity-100",
        "leave-to-class": "opacity-0"
      }, {
        default: _withCtx(() => [
          (_ctx.isApprovingL1 || _ctx.isSendingToL2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_23))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ]))
}